import { HTTP } from "../http/http-common";

export async function getDatas(slug, options) {
  return new Promise((res, rej) => {
    HTTP.get(slug, options)
      .then((response) => {
        res(response.data);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

export async function postDatas(slug, data) {
  return new Promise((res, rej) => {
    HTTP.post(slug, data)
      .then((response) => {
        res(response.data);
      })
      .catch((err) => {
        rej(err);
      });
  });
}